import { z } from 'zod';

export const warehouseModuleSchema = z.object({}).default({});
